export const CHECKOUT_URL = 'https://reparaciones-it.impultienda.ar/checkout/'

/** Total length of the promotional countdown: 00h 17m 34s. */
export const OFFER_SECONDS = 17 * 60 + 34

export const SPOTS_LEFT = 9
export const SPOTS_TOTAL = 100
